import { useEffect } from 'react';
import { logEvent } from 'firebase/analytics';

import MainFooter from '../../../components/Footer/MainFooter';
import AvailableChannels from './AvailableChannels';
import Hero from './Hero';
import WhySlex from './WhySlex';
import Faq from './Faq';
import PreFooter from '../../../components/Footer/PreFooter';
import Section6 from '../../../sections/Homepage/Section6';
import { MyHelmet } from './MyHelmet';
import { analytics } from '../../../config/firebase';

export default function EuroQualifiers() {
  // Firebase analytics
  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_title: 'UEFA Euro Qualifiers 2024 - Landing1',
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }, []);
  return (
    <>
      <MyHelmet />
      <Hero />;
      <AvailableChannels />
      <WhySlex />
      <Section6 />
      <Faq />
      <PreFooter />
      <MainFooter />
    </>
  );
}
